// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"Paa-z","disabled":"Qaa-z","label":"Raa-z"};